import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function EqualityDiversityPolicy() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    EQUALITY AND DIVERSITY POLICY
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    Promoting Inclusivity and Respect
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Policy Information Table */}
        <section style={{ padding: '80px 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '1rem' }}>
                      <tbody>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '30%' }}>Lead Responsibility</td>
                          <td style={{ padding: '20px 30px' }}>Laurence T. Sofowora</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc', width: '25%' }}>Approved by:</td>
                          <td style={{ padding: '20px 30px' }}>Adekunle Ayeni</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Version</td>
                          <td style={{ padding: '20px 30px' }}>V14 - 2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Date of Approval</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Effective from</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2025</td>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Next review date</td>
                          <td style={{ padding: '20px 30px' }}>01/12/2026</td>
                        </tr>
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Policy applicable to</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>ALL EMPLOYEES and FREELANCE STAFF</td>
                        </tr>
                        <tr>
                          <td style={{ padding: '20px 30px', fontWeight: '600', backgroundColor: '#f8fafc' }}>Record of Changes:</td>
                          <td colSpan="3" style={{ padding: '20px 30px' }}>No Changes</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Teaching and Learning Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    TEACHING AND LEARNING
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    We aim to provide all our learners with the opportunity to succeed and to reach the highest level of personal achievement. To do this, we will:
                  </p>

                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '12px' }}>Use contextual data to improve the ways in which we provide support to individuals and groups of learners.</li>
                    <li style={{ marginBottom: '12px' }}>Monitor achievement data by ethnicity, gender and disability and action any gaps.</li>
                    <li style={{ marginBottom: '12px' }}>Take account of the achievement of all learners when planning for future learning and setting challenging targets.</li>
                    <li style={{ marginBottom: '12px' }}>Ensure equality of access for all learners and prepare them for life in a diverse society.</li>
                    <li style={{ marginBottom: '12px' }}>Use materials that reflect the diversity of the college, population, and local community in terms of race, gender and disability, without stereotyping.</li>
                    <li style={{ marginBottom: '12px' }}>Promote attitudes and values that will challenge racist and other discriminatory behaviour or prejudice.</li>
                    <li style={{ marginBottom: '12px' }}>Provide opportunities for learners to appreciate their own culture and celebrate the diversity of other cultures</li>
                    <li style={{ marginBottom: '12px' }}>Encourage class and staff discussions of equality issues which reflect on social stereotypes, expectations, and the impact on learning.</li>
                    <li>Include teaching and classroom-based approaches appropriate for the whole college, which are inclusive and reflective of our learners.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Admissions, Equal Opportunities, Employer Duties, Equality and the Law */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg mb-4" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    ADMISSIONS
                  </h3>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Our admissions arrangements are fair and transparent and do not discriminate on race, gender, disability, or socio-economic factors.
                  </p>
                </div>

                <div className="p-5 shadow-lg mb-4" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    EQUAL OPPORTUNITIES FOR STAFF
                  </h3>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    We are committed to the implementation of equal opportunities principles and the monitoring and active promotion of equality in all aspects of staffing and employment.
                  </p>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    All staff appointments and promotions are made based on merit and ability and in compliance with the governing UK law. However, we ensure wherever possible that the staffing of the college reflects the diversity of our community.
                  </p>
                </div>

                <div className="p-5 shadow-lg mb-4" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    EMPLOYER DUTIES
                  </h3>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    As an employer we ensure that we eliminate discrimination and harassment in our employment practice and actively promote equality across our workforce.
                  </p>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Equality aspects such as gender, race, disability, sexual orientation, gender re-assignment and faith or religion are considered when appointing staff and particularly when allocating Teaching and Learning Responsibilities (TLR) or re-evaluating staff structures, to ensure decisions are free of discrimination.
                  </p>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '10px' }}>
                    Actions to ensure this commitment is met include:
                  </p>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '8px' }}>Monitoring, recruitment, and retention including bullying and harassment of staff</li>
                    <li style={{ marginBottom: '8px' }}>Continued Professional Development (CPD) opportunities for all staff</li>
                    <li>Senior Leadership support to ensure equality of opportunity for all</li>
                  </ul>
                </div>

                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    EQUALITY AND THE LAW
                  </h3>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    There are several statutory duties that must be met by every college in line with legislation from the Race Relations (Amendment) Act (2000), Disability Equality Duty (2005) and Equality Act (2006).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Race Equality Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    RACE EQUALITY
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    This section of the plan reflects the general and specific duties of colleges as detailed in The Race Relations Act 1976 and as amended by The Race Relations (Amendment) Act 2000.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    The General Race Equality Duty requires us to have due regard to the need to:
                  </p>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '8px' }}>Eliminate racial discrimination</li>
                    <li style={{ marginBottom: '8px' }}>Promote equality of opportunity</li>
                    <li>Promote good relations between people of different racial groups.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    Under our specific duty we will:
                  </p>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>Prepare an Equality Plan which includes our written policy for race equality</li>
                    <li style={{ marginBottom: '10px' }}>Assess the impact of our policies, including this Plan, on learners, staff and parents by ethnicity including the achievement levels of these learners</li>
                    <li>Monitor the impact our plans and policies have on learners and staff towards raising the achievement of minority ethnic groups.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Disability Section */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    DISABILITY
                  </h3>
                  
                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    Definition of Disability
                  </h4>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Disability Discrimination Act 2005 (DDA) defines a disabled person as someone who has 'a physical or mental impairment which has a substantial or long-term adverse effect on his or her ability to carry out normal day-to-day activities'.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The DDA 2005 has also extended the definition of disability as follows: People with HIV, multiple sclerosis, and cancer (although not all cancers) are deemed disabled before they experience the long-term and substantial adverse effect on their activities.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Section 18 has been amended so that individuals with a mental illness no longer have to demonstrate that it is "clinically well-recognised", although the person must still demonstrate a long-term and substantial adverse impact on his/her ability to carry out normal day-to-day activities.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    LEGAL DUTIES
                  </h4>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    The Disability Discrimination Act (DDA) 2005 placed a general duty on colleges, requiring them to have due regard for the following when carrying out and delivering services:
                  </p>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>Promoting equality of opportunity between disabled people and other people</li>
                    <li style={{ marginBottom: '10px' }}>Eliminating discrimination and harassment of disabled people that is related to their disability</li>
                    <li style={{ marginBottom: '10px' }}>Promoting positive attitudes towards disabled people</li>
                    <li style={{ marginBottom: '10px' }}>Encouraging participation in public life by disabled people</li>
                    <li>Taking steps to meet disabled people's needs, even if this requires more favourable treatment.</li>
                  </ul>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    Under our specific duty we will:
                  </p>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>Prepare and publish an Equality Plan which covers the requirements for a Disability Equality Scheme identifying our disability equality goals and actions to meet them</li>
                    <li>Review and revise this Plan every three years.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Gender Equality & Sexual Orientation */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg mb-4" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    GENDER EQUALITY
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Gender Equality Duty 2006 places a general and specific duty on colleges to eliminate unlawful discrimination and harassment on the grounds of gender and to promote equality of opportunity between female and male learners and between women and men and transgender people.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    Under our general duty we will actively seek to:
                  </p>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>Eliminate unlawful discrimination and harassment on grounds of sex and gender reassignment</li>
                    <li style={{ marginBottom: '10px' }}>Promote equality between men and women</li>
                    <li style={{ marginBottom: '10px' }}>Under our specific duty we will</li>
                    <li style={{ marginBottom: '10px' }}>Prepare and publish an Equality Plan which identifies our gender equality goals and actions to meet them</li>
                    <li>Review and revise this Plan every three years</li>
                  </ul>
                </div>

                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    SEXUAL ORIENTATION
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    The Equality Act 2006 made provision for regulations to be introduced to extend protection against discrimination on grounds of religion or belief to sexual orientation. The Equality Act (Sexual Orientation) Regulations 2007 came into force on 30 April 2007, and they make discrimination unlawful in goods, facilities, and services on grounds of sexual orientation. For colleges this means admissions, benefits and services for learners and treatment of learners.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Roles and Responsibilities */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    6. Roles/Responsibilities
                  </h3>
                  
                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    The role of the Principal (or senior leader responsible for Equalities)
                  </h4>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    It is the Principal's role to implement the college's Equality.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    It is the Principal's role to ensure that all staff are aware of the Equality Plan and that teachers apply these guidelines fairly in all situations.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Principal ensures that all appointments panels give due regard to this plan, so that no one is discriminated against when it comes to employment or training opportunities.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Principal promotes the principle of equal opportunity when developing the curriculum and promotes respect for other people and equal opportunities to participate in all aspects of college life.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    The Principal treats all incidents of unfair treatment and any incidents of bullying or discrimination, including racist incidents, with due seriousness.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    The Role of all Staff: teaching and non-teaching
                  </h4>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All staff will ensure that all learners are treated fairly, equally and with respect and will maintain awareness of the college's Equality Plan.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All staff will strive to provide material that gives positive images based on race, gender and disability and challenges stereotypical images.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All staff will challenge any incidents of prejudice, racism or homophobia and record any serious incidents, drawing them to the attention of the Principal.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    Teachers support the work of ancillary or support staff and encourage them to intervene in a positive way against any discriminatory incidents.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Tackling Discrimination */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    TACKLING DISCRIMINATION
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Harassment on account of race, gender, disability, or sexual orientation is unacceptable and is not tolerated within the college environment.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    All staff are expected to deal with any discriminatory incidents that may occur. They are expected to know how to identify and challenge prejudice and stereotyping; and to support the full range of diverse needs according to a pupil's individual circumstances.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Racist and homophobic incidents and other incidents of harassment or bullying are dealt with by the member of staff present, escalating to a teacher/Principal where necessary. All incidents are reported to the Principal and racist incidents are reported to the governing body and local authority on a quarterly basis.
                  </p>

                  <h4 style={{ color: '#7B3F9E', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                    What is a Discriminatory Incident?
                  </h4>
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    Harassment on grounds of race, gender, disability, sexual orientation, or other factors such as socio-economic status, can take many forms including verbal or physical abuse, name calling, exclusion from groups and games, unwanted looks or comments, jokes, and graffiti.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0' }}>
                    A racist incident is defined by the Stephen Lawrence Inquiry Report (1999) as: 'any incident which is perceived to be racist by the victim or any other person'.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Types of Discriminatory Incident */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Types of Discriminatory Incident
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '15px' }}>
                    Types of discriminatory incidents that can occur are:
                  </p>
                  <ul style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0', paddingLeft: '25px' }}>
                    <li style={{ marginBottom: '10px' }}>Physical assault against a person or group because of their colour, ethnicity, nationality, disability, sexual orientation, or gender</li>
                    <li style={{ marginBottom: '10px' }}>Use of derogatory names, insults, and jokes</li>
                    <li style={{ marginBottom: '10px' }}>Racist, sexist, homophobic or discriminatory graffiti</li>
                    <li style={{ marginBottom: '10px' }}>Provocative behaviour such as wearing racist, sexist, homophobic or discriminatory badges or insignia</li>
                    <li style={{ marginBottom: '10px' }}>Bringing discriminatory material into college</li>
                    <li style={{ marginBottom: '10px' }}>Verbal abuse and threats</li>
                    <li style={{ marginBottom: '10px' }}>Incitement of others to discriminate or bully due to victim's race, disability, gender, or sexual orientation</li>
                    <li style={{ marginBottom: '10px' }}>Discriminatory comments during discussion</li>
                    <li style={{ marginBottom: '10px' }}>Attempts to recruit others to discriminatory organisations and groups</li>
                    <li style={{ marginBottom: '10px' }}>Ridicule of an individual for difference e.g., food, music, religion, dress etc.</li>
                    <li>Refusal to co-operate with other people on grounds of race, gender, disability, or sexual orientation.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Responding to and Reporting Incidents */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    Responding to and Reporting Incidents
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px' }}>
                    It should be clear to learners and staff how they report incidents. All staff, teaching, and non-teaching, should view dealing with incidents as vital to the well-being of the whole college.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '30px' }}>
                    Procedure for responding and reporting is outlined below:
                  </p>
                  {/* Incident Flow */}
                  <div style={{ padding: '30px 20px', backgroundColor: '#f8fafc', borderRadius: '12px', marginBottom: '20px' }}>
                    {/* Step 1: Incident */}
                    <div className="text-center mb-2">
                      <div className="p-3" style={{ 
                        border: '2px solid #1e293b', 
                        borderRadius: '4px', 
                        display: 'inline-block', 
                        backgroundColor: '#fff',
                        minWidth: '200px'
                      }}>
                        <strong style={{ fontSize: '0.95rem' }}>Incident</strong>
                      </div>
                    </div>
                    
                    {/* Arrow down */}
                    <div className="text-center mb-2">
                      <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                    </div>

                    {/* Step 2: Member of staff */}
                    <div className="text-center mb-2">
                      <div className="p-3" style={{ 
                        border: '2px solid #1e293b', 
                        borderRadius: '4px', 
                        maxWidth: '650px', 
                        margin: '0 auto', 
                        backgroundColor: '#fff'
                      }}>
                        <span style={{ fontSize: '0.9rem' }}>Member of staff to investigate further (if incident reported) or challenge behaviour immediately</span>
                      </div>
                    </div>

                    {/* Two arrows down */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                      <div style={{ width: '45%', textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>
                      <div style={{ width: '10%' }}></div>
                      <div style={{ width: '45%', textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>
                    </div>

                    {/* Step 3: Two response boxes */}
                    <div className="row g-3 mb-2" style={{ maxWidth: '800px', margin: '0 auto 8px' }}>
                      <div className="col-6">
                        <div className="p-3" style={{ 
                          border: '2px solid #1e293b', 
                          borderRadius: '4px', 
                          backgroundColor: '#fff', 
                          height: '100%',
                          textAlign: 'center'
                        }}>
                          <span style={{ fontSize: '0.9rem' }}><strong>Response to victim and family</strong></span>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="p-3" style={{ 
                          border: '2px solid #1e293b', 
                          borderRadius: '4px', 
                          backgroundColor: '#fff', 
                          height: '100%',
                          textAlign: 'center'
                        }}>
                          <span style={{ fontSize: '0.9rem' }}><strong>Response to perpetrator and family</strong></span>
                        </div>
                      </div>
                    </div>

                    {/* Two arrows converging */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                      <div style={{ width: '45%', textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>
                      <div style={{ width: '10%' }}></div>
                      <div style={{ width: '45%', textAlign: 'center' }}>
                        <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                      </div>
                    </div>

                    {/* Step 4: Action taken */}
                    <div className="text-center mb-2">
                      <div className="p-3" style={{ 
                        border: '2px solid #1e293b', 
                        borderRadius: '4px', 
                        maxWidth: '650px', 
                        margin: '0 auto', 
                        backgroundColor: '#fff'
                      }}>
                        <span style={{ fontSize: '0.9rem' }}>Action taken to address issue with year cohort/college if necessary, e.g. through meetings</span>
                      </div>
                    </div>

                    {/* Arrow down */}
                    <div className="text-center mb-2">
                      <div style={{ fontSize: '1.5rem', color: '#1e293b', lineHeight: '1' }}>↓</div>
                    </div>

                    {/* Step 5: Final box */}
                    <div className="text-center">
                      <div className="p-3" style={{ 
                        border: '2px solid #1e293b', 
                        borderRadius: '4px', 
                        maxWidth: '650px', 
                        margin: '0 auto', 
                        backgroundColor: '#fff'
                      }}>
                        <div style={{ fontSize: '0.9rem', marginBottom: '8px' }}><strong>Incident form to be completed and filed.</strong></div>
                        <div style={{ fontSize: '0.9rem' }}>Incidents to be reported to SLT and local authority on a quarterly basis.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Review of Progress and Impact */}
        <section style={{ padding: '0 0 60px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ color: '#0369a1', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                    REVIEW OF PROGRESS AND IMPACT
                  </h3>
                  
                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '20px', fontWeight: '600' }}>
                    We will review progress against our Equality Plan annually and review the entire plan and accompanying action plan on a three-year cycle.
                  </p>

                  <p style={{ color: '#334155', fontSize: '1.05rem', lineHeight: '1.9', marginBottom: '0', fontWeight: '600' }}>
                    We make regular assessments of learners' learning and use this information to track learner progress. As part of this process, we regularly monitor achievement by ethnicity, gender, and disability, to ensure that all groups of learners are making the best possible progress and take appropriate action to address any gaps.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Action Plan - Page 8 */}
        <section style={{ padding: '0 0 40px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-11">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{ backgroundColor: '#0369a1', padding: '20px 30px' }}>
                    <h3 style={{ color: '#fff', fontSize: '1.8rem', fontWeight: '700', marginBottom: '0', textAlign: 'center' }}>
                      Action Plan
                    </h3>
                  </div>
                  
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '0.95rem' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #cbd5e1' }}>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '12%' }}>Equality Strand</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '25%' }}>Action</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '28%' }}>Success criteria</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '13%' }}>By whom</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '10%' }}>Time</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '12%' }}>Achieved/Success</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Row 1 */}
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px', fontWeight: '600', verticalAlign: 'top' }}>All</td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To publish and promote the equality plan to all stakeholders.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            All stakeholders to have access to published equality plan. Stakeholders to have opportunities to assess the impact of the plan influencing the evaluation process and future target setting.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Principal to organise and delegate.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>Ongoing</td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                        </tr>

                        {/* Row 2 */}
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px', fontWeight: '600', verticalAlign: 'top' }}>All</td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To monitor and analyse learner achievement by race, gender and disability and act on any trends or patterns in data that require additional support.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To ensure all learners are given the opportunity to make a positive contribution to the life of the college.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Learner achievement for equality groups above national average, and where there are gaps, these are narrowed through effective monitoring and intervention.<br/><br/>
                            More diversity reflected in college displays and materials for lessons
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                        </tr>

                        {/* Row 3 */}
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px', fontWeight: '600', verticalAlign: 'top' }}>All</td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To ensure that displays in classrooms and corridors promote diversity in terms of race, gender and disability.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            All college events have learners from all groups participating, with monitoring of groups where there is less take up.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                        </tr>

                        {/* Bottom rows - partial */}
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px', fontWeight: '600', verticalAlign: 'top' }}>All</td>
                          <td colSpan="2" style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            SLT<br/><br/>
                            Quarterly
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Ongoing<br/><br/>
                            9
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            SLT<br/><br/>
                            Staff
                          </td>
                        </tr>

                        <tr>
                          <td colSpan="2" style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td colSpan="2" style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Ongoing
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Staff
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div style={{ padding: '20px 30px', backgroundColor: '#f8fafc', textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                    <span style={{ fontSize: '0.9rem', color: '#64748b' }}>8 | Page</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Action Plan - Page 11 - Specific Duties */}
        <section style={{ padding: '0 0 80px' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-11">
                <div className="shadow-lg" style={{
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }}>
                  <div className="table-responsive">
                    <table className="table mb-0" style={{ fontSize: '0.95rem' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #cbd5e1' }}>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '15%' }}>Equality Strand</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '22%' }}>Action</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '25%' }}>Success criteria</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '15%' }}>By whom</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '10%' }}>Time</th>
                          <th style={{ padding: '15px 20px', fontWeight: '700', width: '13%' }}>Achieved/Success</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Race Equality Duty */}
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px', fontWeight: '600', verticalAlign: 'top' }}>
                            Race Equality<br/>Duty
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To identify, respond and report racist incidents as outlined.<br/><br/>
                            To report the figures to the Governing body on a quarterly basis.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Staff, parents and learners are happy with the effectiveness of response made by Teaching staff /SLT.<br/><br/>
                            Staff followed guidance consistently and effectively as outlined above.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Principal<br/><br/>
                            College staff (Monitored by SLT)
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Ongoing<br/><br/>
                            Ongoing
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                        </tr>

                        {/* Gender Equality Duty */}
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px', fontWeight: '600', verticalAlign: 'top' }}>
                            Gender Equality<br/>Duty
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To ensure opportunities arranged within college have an appropriate balance between males and females
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Equal representation / opportunities for males and females.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            SLT, College staff
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Ongoing
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                        </tr>

                        {/* Disability Equality Duty */}
                        <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
                          <td style={{ padding: '20px', fontWeight: '600', verticalAlign: 'top' }}>
                            Disability Equality<br/>Duty
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To ensure learners with a disability are actively involved in college activities.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            To ensure there is effective progression between classes.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Learners with a disability participate in extra- curricular activities.
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                        </tr>

                        {/* Bottom row */}
                        <tr>
                          <td colSpan="3" style={{ padding: '20px', verticalAlign: 'top' }}></td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Class teacher<br/>
                            SLT, College staff
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}>
                            Ongoing
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'top' }}></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div style={{ padding: '20px 30px', backgroundColor: '#f8fafc', textAlign: 'right', borderTop: '1px solid #e2e8f0' }}>
                    <span style={{ fontSize: '0.9rem', color: '#64748b' }}>11 | Page</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default EqualityDiversityPolicy;